export default function getCurrentYear() {
	var now = new Date()
	var thisYear = now.getFullYear()
	var output = document.getElementsByClassName('output')

	$('.output-year').html(thisYear)
}
